if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}


const observer = lozad();
observer.observe();

slickCollection();
galleryClick();
slickAnnouncement();

window.addEventListener('DOMContentLoaded', function () {
  slickProduct();
  hideSearch();
  cartUpdate();
  slickBlog();
  addToDropdown();
  slickArticleFirst();
  replaceMapBlock();
  firstVideo();
  interPrButton();
  customAddTo()
  normalizeDanishReviewCounts();
  // setTimeout(() => customAddTo(), 2000)
  // subscribeAjax();
})

// function subscribeAjax() {
//   const blocks = document.querySelectorAll(".signup-section");
//   console.log('works');
//   if (blocks.length > 0) {
//     console.log('exist');
//     blocks.forEach((block) => {
//       const form = block.querySelector("form");
//       console.log(form);
//       $(form).submit(function (event) {
//         event.preventDefault();
//         event.stopPropagation();
//         console.log(event);
//         window.Shopify.recaptchaV3.addToken(form, "customer");
//         $.ajax({
//           type: "POST",
//           url: $(this).attr("action"),
//           data: $(this).serialize(),
//           success: function (response) {
//             if (response.success) {
//               $(this)
//                 .find("#form-response")
//                 .html("<p>Subscription successful!</p>");
//             } else {
//               $(this).find("#form-response").html(
//                 "<p>Subscription failed. Please try again.</p>"
//               );
//             }
//           },
//           error: function () {
//             $(this).find("#form-response").html(
//               "<p>Something went wrong. Please try again later.</p>"
//             );
//           },
//         });
//       });
//     });
//   }
// }

function variantSlick() {
  const galleries = document.querySelectorAll('.opkl-media-gallery');
}

function interPrButton() {

  const button = document.querySelector('.fixed-add');
  if (button) {
    const pays = document.querySelector('.payment-icons');

    window.addEventListener('scroll', () => {
      const chat = document.querySelector('#smartsupp-widget-container [data-testid="widgetButtonFrame"]');
      if (!chat) return
      let scroll = window.innerHeight + window.scrollY;
      // console.log(`${pays.offsetTop + window.innerHeight}---${scroll}`);

      if (pays.offsetTop + window.innerHeight < scroll) {
        button?.classList.add('active');
        chat?.classList.add('moveup');
      } else {
        button?.classList.remove('active')
        chat?.classList.remove('moveup');
      }

      // Old code
      // if (chat && pays) {
      //   if (pays.offsetTop + window.innerHeight < scroll) {
      //     button.classList.add('active');
      //     chat.classList.add('moveup');
      //   } else {
      //     button.classList.remove('active')
      //     chat.classList.remove('moveup');
      //   }
      // }
    })
  }

}

function customAddTo() {
  const blocks = document.querySelectorAll('.test-add');
  if (blocks.length > 0) {
    const variantDropdowns = document.querySelectorAll('.variant-dropdown');
    const variantButtons = document.querySelectorAll('[data-opk-variants]');

    variantButtons.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const id = el.dataset.productId;
        addAjax(id, el);
        variantDropdowns.forEach(e => {
          e.classList.remove('show')
        })
      })
    })

    blocks.forEach(block => {
      // const unavailableOption = block.getAttribute('data-product-variant-metafield');
      // if (unavailableOption) {
      //   console.log(unavailableOption)
      // }

      block.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const variantDropdown = evt.currentTarget.previousElementSibling ? evt.currentTarget.previousElementSibling : false;
        const closeDropdown = () => {
          variantDropdown.classList.remove('show');
          window.removeEventListener('click', closeDropdown);
        }

        if (variantDropdown !== false && variantDropdown.classList.contains('variant-dropdown')) {
          if (variantDropdown.classList.contains('show')) {
            closeDropdown();
          } else {
            variantDropdown.classList.add('show');
            window.addEventListener('click', closeDropdown);
          }
        } else {
          const id = block.dataset.productId;
          addAjax(id, block);
          variantDropdowns.forEach(e => {
            block.classList.remove('show')
          })
        }
      })
    })
  }
}

function addAjax(id, e) {
  let formData = {
    'items': [{
      'id': id,
      'quantity': 1
    }],
    'sections': 'opkl-header'
  };
  $.ajax({
    url: window.Shopify.routes.root + 'cart/add.js',
    dataType: 'json',
    contentType: "application/json",
    method: 'post',
    data: JSON.stringify(formData),
    beforeSend: function () {
      e.disabled = true
      e.classList.add('disabled')

    },
    success: function (data) {
      e.disabled = false;
      e.classList.remove('disabled');
      const parser = new DOMParser();
      const cart = parser.parseFromString(data.sections['opkl-header'], 'text/html').querySelector('[data-cart-icon-opk]');
      const liveCart = document.querySelector('[data-cart-icon-opk]');
      liveCart.innerHTML = cart.innerHTML;
    }
  })
}

function firstVideo() {

  var y = document.querySelectorAll('.section-product .product-media');
  if (y.length > 0) {
    var x = document.querySelectorAll('.opkl-thumbnails__thumbs .slick-slide');
    if (y.length > 1) {
      document.querySelector('.opkl-thumbnails [data-slick-index="1"]').click();
      // $('.opkl-thumbnails__thumbs [data-slick-index="1"]')[0].click();

      setTimeout(() => {
        document.querySelector('.product-grid__media').classList.add('active');
      }, 400)

    } else {
      document.querySelector('.product-grid__media').classList.add('active');
    }
  }


}

function cartUpdate() {
  const cart = document.querySelector('#cartform');
  if (cart) {
    const items = cart.querySelectorAll('.item');
    const subtotalBlock = document.querySelector('.totals__subtotal-value');
    let totalPrice = 0;
    let totalComparePrice = 0;


    items.forEach(el => {
      let qty = parseInt(el.querySelector('input[name="updates[]"]').value);
      const input = el.querySelector('input[name="updates[]"]');
      const itemId = el.dataset.itemId;
      const qtyBtns = el.querySelectorAll('.qty-btn');
      const remove = el.querySelector('.cart-remove');
      const price = el.querySelector('.col-price .theme-money');
      const comparePriceEl = el.querySelector('.opk-compare-money')
      let comparePrice = '';
      if (comparePriceEl) {
        comparePrice = comparePriceEl.getAttribute('data-compare-at-price-one');
      }
      const total = el.querySelector('.col-total .theme-money');
      const compareTotal = el.querySelector('.col-total .opk-compare-money');
      let updates = {};
      let subtotal = 0;

      input.addEventListener('input', (evt) => {
        try {
          document.querySelector('button[name="checkout"]').setAttribute("disabled", "");
          setTimeout(() => {
            document.querySelector('button[name="checkout"]').removeAttribute("disabled");
          }, 4800)
        } catch (e) { }
        console.log(evt);
        qty = evt.data;
        updates[itemId] = qty;
        const sum = (Number(price.textContent.replace(',', '.')) * qty).toFixed(2);
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: { updates: updates, sections: 'opkl-header' },
          dataType: 'json',
          beforeSend: function () {
            $(total).fadeOut();
          },
          success: function (data) {
            const parser = new DOMParser();
            const cart = parser.parseFromString(data.sections['opkl-header'], 'text/html').querySelector('[aria-label="Cart"]');
            const liveCart = document.querySelector('[aria-label="Cart"]');
            liveCart.innerHTML = cart.innerHTML;
            Shopify.getCart(function (cart) {

              if (data.item_count != cart.item_count) {
                location.reload();
              }

              let subtotal = 0;
              data.items.forEach(e => {
                subtotal += e.final_line_price;
              })
              subtotal = theme.Shopify.formatMoney(subtotal, theme.money_format);
              subtotalBlock.textContent = `${subtotal}`;
              if (qty > 0) {
                total.textContent = sum;
                $(total).fadeIn();
              } else {
                $(el).fadeOut(function () {
                  el.remove();
                  if (cart.querySelectorAll('.item').length == 0) {
                    window.location.reload();
                  }
                })
              }
            }.bind(this));
          }
        }
        $.ajax(params);
      })
      if (remove) {
        remove.addEventListener('click', (evt) => {
          try {
            document.querySelector('button[name="checkout"]').setAttribute("disabled", "");
            setTimeout(() => {
              document.querySelector('button[name="checkout"]').removeAttribute("disabled");
            }, 4800)
          } catch (e) { }
          evt.preventDefault();
          evt.stopPropagation();
          updates[itemId] = 0;
          var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates, sections: 'opkl-header' },
            dataType: 'json',
            success: function (data) {
              const parser = new DOMParser();
              const cart = parser.parseFromString(data.sections['opkl-header'], 'text/html').querySelector('[data-cart-icon-opk]');
              const liveCart = document.querySelector('[data-cart-icon-opk]');
              liveCart.innerHTML = cart.innerHTML;
              Shopify.getCart(function (cart) {

                if (data.item_count != cart.item_count) {
                  location.reload();
                }

                data.items.forEach(e => {
                  subtotal += e.final_line_price;
                });
                subtotal = theme.Shopify.formatMoney(subtotal, theme.money_format);
                subtotalBlock.textContent = `${subtotal}`;
                $(el).fadeOut(function () {
                  el.remove();
                  if (cart.querySelectorAll('.item').length == 0) {
                    window.location.reload();
                  }
                });
              }.bind(this));
            }
          }
          $.ajax(params);
        })
      }
      qtyBtns.forEach(e => {
        e.addEventListener('click', (event) => {
          try {
            document.querySelector('button[name="checkout"]').setAttribute("disabled", "");
            setTimeout(() => {
              document.querySelector('button[name="checkout"]').removeAttribute("disabled");
            }, 4800)
          } catch (e) { }
          e.dataset.direction == '+' ? qty++ : qty--;
          updates[itemId] = qty;
          const sum = (Number(price.textContent.replace(',', '.')) * qty).toFixed(2);
          let compareSum = '';
          if (comparePrice != '') {
            compareSum = (Number(comparePrice.replace(',', '.')) * qty).toFixed(2);
          }
          var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates, sections: 'opkl-header' },
            dataType: 'json',
            beforeSend: function () {
              $(total).fadeOut();
              if (compareTotal) {
                $(compareTotal).fadeOut();
              }
            },
            success: function (data) {
              const parser = new DOMParser();
              const cart = parser.parseFromString(data.sections['opkl-header'], 'text/html').querySelector('[aria-label="Cart"]');
              const liveCart = document.querySelector('[aria-label="Cart"]');
              liveCart.innerHTML = cart.innerHTML;
              Shopify.getCart(function (cart) {

                if (data.item_count != cart.item_count) {
                  location.reload();
                }

                let subtotal = 0;
                data.items.forEach(e => {
                  subtotal += e.final_line_price;
                })
                subtotal = theme.Shopify.formatMoney(subtotal, theme.money_format);
                subtotalBlock.textContent = `${subtotal}`;
                if (qty > 0) {
                  total.textContent = sum;
                  if (compareTotal) {
                    console.log('compareSUM', compareSum)
                    compareTotal.textContent = compareSum;

                    $(compareTotal).fadeIn();
                  }
                  $(total).fadeIn();
                } else {
                  $(el).fadeOut(function () {
                    el.remove();
                    console.log(cart.querySelectorAll('.item').length);
                    if (cart.querySelectorAll('.item').length == 0) {
                      window.location.reload();
                    }
                  })
                }
              }.bind(this));
            }
          }
          $.ajax(params);

          // Opklopper discount 
          // const elementsWithPrice = el.querySelectorAll('[data-total-item-price]');
          // const elementsWithComparePrice = el.querySelectorAll('[data-total-compare-at-price]');

          // elementsWithPrice.forEach(priceElement )
          const savingHTML = document.getElementById("opk-saving");

          if (event.target.getAttribute("data-direction") == '+') {
            const comparePriceOne = el.querySelector('[data-compare-at-price-one]');
            const priceOne = el.querySelector('[data-price-one]').getAttribute("data-price-one");
            const value = savingHTML.textContent
            let cleanedValue = value.replace(/[€\s]/g, "");
            cleanedValue = cleanedValue.replace('.', '').replace(',', '') * 1
            console.log(parseFloat(comparePriceOne.getAttribute('data-compare-at-price-one').replace(",", '.') * 1))
            const change = comparePriceOne.getAttribute('data-compare-at-price-one').replace(",", '').replace(".", ',') * 1 - priceOne.replace(",", '').replace(".", ',') * 1
            const finalSavingValue = ((cleanedValue + change) / 100).toFixed(2)

            let formattedNumber = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(finalSavingValue);

            savingHTML.textContent = formattedNumber + '€';
          }

          if (event.target.getAttribute("data-direction") == '-') {
            const comparePriceOne = el.querySelector('[data-compare-at-price-one]');
            const priceOne = el.querySelector('[data-price-one]').getAttribute("data-price-one");
            const value = savingHTML.textContent
            let cleanedValue = value.replace(/[€\s]/g, "");
            cleanedValue = cleanedValue.replace('.', '').replace(',', '') * 1
            console.log(parseFloat(comparePriceOne.getAttribute('data-compare-at-price-one').replace(",", '.') * 1))
            const change = comparePriceOne.getAttribute('data-compare-at-price-one').replace(",", '').replace(".", ',') * 1 - priceOne.replace(",", '').replace(".", ',') * 1
            const finalSavingValue = ((cleanedValue - change) / 100).toFixed(2)

            let formattedNumber = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(finalSavingValue);

            savingHTML.textContent = formattedNumber + '€';
          }




          // console.log('Op', op)
          // savingHTML.textContent = op.toFixed(2);
        })
      })

    })


  }
}

function hideSearch() {
  const block = document.querySelector('.header-search-inline');
  if (block) {
    const blocks = document.querySelectorAll('.header-search-inline');
    window.addEventListener('click', function (event) {
      // console.log('click');
      blocks.forEach(e => {
        let nod = e.querySelector('.header-search__results');
        let prNod = e.querySelector('.header-search__results-wrapper');
        let input = e.querySelector('.input-with-button__input');
        if (event.target == nod || event.target == prNod || event.target == input) {

        } else {
          if (nod.classList.contains('header-search__results--show')) {
            nod.classList.remove('header-search__results--show');
            nod.innerHTML = '';
          }
        }
      })
    })
  }
}

function slickCollection() {
  const block = document.querySelector('.slick-opkl-collection');
  if (block) {
    $('.slick-opkl-collection').on('init', function (event, slick) {
      $('.slick-opkl-collection').css('opacity', '1');
    });
    const products = block.dataset.productsRow;
    $('.slick-opkl-collection').slick({
      infinite: true,
      slidesToShow: products,
      slidesToScroll: 1,
      dots: true,
      prevArrow: [
        '<button type="button" class="slick-prev" aria-label="', theme.strings.previous, '">',
        '<span class="hide-until-sm">',
        `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.00024 10.6395H25.0002M1.00024 10.6395L10.6799 20.2784M1.00024 10.6395L10.6799 1" stroke="#1B1B1B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `,
        '</span>',
        '<span class="show-until-sm">',
        `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.00024 10.6395H25.0002M1.00024 10.6395L10.6799 20.2784M1.00024 10.6395L10.6799 1" stroke="#1B1B1B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `,
        '</span>',
        '</button>'].
        join(''),
      nextArrow: [
        '<button type="button" class="slick-next" aria-label="', theme.strings.next, '">',
        '<span class="hide-until-sm">',
        `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 10.6388H1.00037M25 10.6388L15.3205 1M25 10.6388L15.3205 20.2781" stroke="#1B1B1B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        '</span>',
        '<span class="show-until-sm">',
        `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 10.6388H1.00037M25 10.6388L15.3205 1M25 10.6388L15.3205 20.2781" stroke="#1B1B1B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        '</span>',
        '</button>'].
        join(''),
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },


        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
            arrows: true,
            dots: true
          }
        }]
    });
  }
}

function slickBlog() {
  $('.featured-articles').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },


      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
          arrows: true,
          dots: true
        }
      }]
  });
}

function addToDropdown() {
  // console.log(theme);
  const block = document.querySelector('.opkl-product-options');
  if (block) {
    let buttons = block.querySelectorAll('.cc-select__btn');
    const $container = $('.product');

    $(window).on("cc-variant-updated", (e, args) => {
      // const badges = document.querySelector('.product-form-block .product-price')
      buttons.forEach((e, i) => {
        const icon = e.lastElementChild;

        let variantTitle
        if (args.variant.options[i].length <= 15) {
          variantTitle = args.variant.options[i]
        } else {
          variantTitle = args.variant.options[i].slice(0, 15) + '...';
        }

        e.textContent = variantTitle;
        e.appendChild(icon);
      })
    });

    const selectors = block.querySelectorAll('.cc-select__option');
    selectors.forEach(e => {
      e.addEventListener('click', function () {
        const icon = e.parentElement.previousElementSibling.lastElementChild;
        e.parentElement.previousElementSibling.textContent = e.textContent;
        e.parentElement.previousElementSibling.appendChild(icon);
        let selectedOptions = [];
        buttons.forEach(e => {
          selectedOptions.push(e.textContent.trim());
        })

        var variant = Object.values(theme.productData)[0].variants.find(
          (v) => v.options.every((val, index) => val === selectedOptions[index]));

        element = document.querySelector(`.product-options input[value="${e.textContent.trim()}"]`);

        element.checked = true;
        // console.log(variant.id);
        theme.OptionManager.updateProductDetails(variant, $container, true);
        let sels = document.querySelectorAll('.js-product-form select');
        sels.forEach(e => {
          e.value = variant.id;
        })
      })
    })
  }
}

function slickArticleFirst() {
  $('.articles-slider-slick').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false
  });
}

function replaceMapBlock() {
  const block = document.querySelector('.map-tab-result');
  if (block) {
    const root = document.querySelector('#frm-storelocator-search');
    root.appendChild(block);
    // document.querySelector('.storeifyapps-storelocator-equal .map-tab-result').remove();
    const reset = document.querySelector('#reset-search');
    const search = document.querySelector('#submit-search');
    reset.textContent = reset.title;
    const icon = `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5621 16.6966L14.4034 12.5379C15.4586 11.2345 16.0793 9.55862 16.0793 7.75862C16.0793 3.47586 12.6034 0 8.32069 0C4.03793 0 0.5 3.47586 0.5 7.75862C0.5 12.0414 3.97586 15.5172 8.25862 15.5172C10.0586 15.5172 11.7345 14.8966 13.0379 13.8414L17.1966 18L18.5621 16.6966ZM2.36207 7.75862C2.36207 4.53103 5.03103 1.86207 8.25862 1.86207C11.4862 1.86207 14.1552 4.53103 14.1552 7.75862C14.1552 10.9862 11.4862 13.6552 8.25862 13.6552C5.03103 13.6552 2.36207 10.9862 2.36207 7.75862Z" fill="white"/>
    </svg>`;
    search.innerHTML = icon + search.title;
    search.classList.add('btn');
    search.setAttribute('style', 'color:white !important; background:black !important')
  }
}

function slickProduct() {
  const galleries = document.querySelectorAll('.opkl-media-gallery');
  if (galleries.length > 0) {
    galleries.forEach(e => {
      const gallery = e.querySelector('.slick-media-gallery');
      const thumbs = e.querySelector('.opkl-thumbnails__thumbs');
      // console.log(thumbs);
      $(gallery).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: thumbs,
        dots: false,
        prevArrow: [
          '<button type="button" class="slick-prev" aria-label="', theme.strings.previous, '">',
          `<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path>
          </svg>
          `,
          '</button>'].
          join(''),
        nextArrow: [
          '<button type="button" class="slick-next" aria-label="', theme.strings.next, '">',
          `<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
          </svg>`,
          '</button>'].
          join(''),
      });
      $(thumbs).slick({
        infinite: true,
        slidesToShow: 5,
        vertical: true,
        // verticalSwiping: true,
        swipeToSlide: true,
        centerMode: true,
        dots: false,
        asNavFor: gallery,
        focusOnSelect: true,
        prevArrow: [
          '<button type="button" class="slick-prev" aria-label="', theme.strings.previous, '">',
          `<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path>
          </svg>
          `,
          '</button>'].
          join(''),
        nextArrow: [
          '<button type="button" class="slick-next" aria-label="', theme.strings.next, '">',
          `<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
          </svg>`,
          '</button>'].
          join(''),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              swipeToSlide: true,
              centerMode: false,
              vertical: false,
              verticalSwiping: false,
              dots: false,
              asNavFor: '.slick-media-gallery',
            }
          }
        ]
      })
      $(window).on("cc-variant-updated", (e, args) => {
        const src = args.variant.featured_media.preview_image.src;
        const id = args.variant.featured_media.id;
        const image = gallery.querySelector(`[data-media-id="${id}"]`);
        if (image) {
          const index = image.dataset.slickIndex;
          const stickCartImage = document.querySelector('.stick-cart-image img');
          stickCartImage.src = src;
          $(gallery).slick('slickGoTo', index);
        }
      });
    })

  }
}

function slickAnnouncement() {
  $('.announcement .announcement-flex').on('init', function (event, slick) {
    document.querySelector('.announcement-flex').classList.add('active');
  });
  $('.announcement .announcement-flex').slick(
    {

      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 99999,
          settings: 'unslick'
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 500
          }
        }
      ]
    }
  );
}

function galleryClick() {
  const gallery = document.querySelector('.opkl-media-gallery');
  $(gallery).on('click', '.product-media__link', function (e) {
    e.preventDefault();

    var images = [];
    var currentIndex = 0;
    var $thumbs = $(gallery).find('.thumb--media-image');

    if ($thumbs.length) {
      var clickedMediaId = e.currentTarget.closest('.product-media').dataset.mediaId;

      $thumbs.each(function () {
        var $imgThumb = $(this).find('.thumb__image').clone();
        images.push({
          thumbTag: $imgThumb,
          zoomUrl: $(this).attr('href')
        });
      });

      $thumbs.each(function (thisIndex) {
        if (this.dataset.mediaId === clickedMediaId) {
          currentIndex = thisIndex;
          return;
        }
      });
    } else {
      var $imgThumb = $(this).find('.thumb__image').clone();
      images.push({
        thumbTag: $imgThumb,
        zoomUrl: $(this).attr('href')
      });
    }

    theme.buildGalleryViewer({
      images: images,
      current: currentIndex,
      zoom: $(this).data('enable-zoom'),
      prev: theme.icons.arrowLeft,
      next: theme.icons.arrowRight,
      close: theme.icons.close
    });
  });
}


// const showVariantsLogic = () => {
//   const variantButtons = document.querySelectorAll('[data-opkl-variants-btn]');

//   if (variantButtons) {
//     variantButtons.forEach((button) => {
//       button.addEventListener('click', () => {
//         console.log('Yea we got this ')
//       })
//     })
//   }
// }

// showVariantsLogic()



function normalizeDanishReviewCounts() {
  const locale = (document.documentElement.lang || '').toLowerCase();
  if (!locale.startsWith('da')) return;

  const normalizeBadge = (badge) => {
    const count = badge.dataset.numberOfReviews;
    const countText = badge.querySelector('.jdgm-prev-badge__text');
    if (!count || !countText) return;

    const normalizedText = `(${count})`;
    if (countText.textContent.trim() !== normalizedText) {
      countText.textContent = normalizedText;
    }
  };

  const normalizeWithin = (root) => {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches('.jdgm-prev-badge')) {
      normalizeBadge(root);
    }
    root.querySelectorAll('.jdgm-prev-badge').forEach(normalizeBadge);
  };

  normalizeWithin(document);

  [250, 1000, 2500].forEach((delay) => {
    window.setTimeout(() => normalizeWithin(document), delay);
  });
  window.addEventListener('load', () => normalizeWithin(document), { once: true });

  const reviewCountObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const badge = mutation.target.parentElement?.closest('.jdgm-prev-badge');
        if (badge) normalizeBadge(badge);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) normalizeWithin(node);
      });
    });
  });

  reviewCountObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
}
